import { render, staticRenderFns } from "./ChatIntro.vue?vue&type=template&id=4a0bf554&scoped=true"
import script from "./ChatIntro.vue?vue&type=script&lang=js"
export * from "./ChatIntro.vue?vue&type=script&lang=js"
import style0 from "./ChatIntro.vue?vue&type=style&index=0&id=4a0bf554&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0bf554",
  null
  
)

export default component.exports